import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, Check, AlertCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * ShareTarget - Réception des partages iOS/Android
 * Crée automatiquement une cible dans la file d'attente
 */
const ShareTarget = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Ajout à la file d\'attente...');

  useEffect(() => {
    const createTarget = async () => {
      const title = searchParams.get('title') || '';
      const text = searchParams.get('text') || '';
      const url = searchParams.get('url') || '';

      // Construire le titre : priorité au title, sinon text, sinon URL
      const targetTitle = title || text || url;
      const targetUrl = url || '';

      if (!targetTitle && !targetUrl) {
        setStatus('error');
        setMessage('Aucun contenu à partager');
        setTimeout(() => navigate('/'), 2000);
        return;
      }

      try {
        const token = localStorage.getItem('auth_token');
        if (!token) {
          setStatus('error');
          setMessage('Connexion requise');
          setTimeout(() => navigate('/login'), 1500);
          return;
        }

        // Créer la cible directement
        await axios.post(`${API}/api/targets`, {
          title: targetTitle.slice(0, 200), // Limiter la longueur
          url: targetUrl || null,
          priority: 'normal',
          va: false,
          source: 'PWA Share Target'
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setStatus('success');
        setMessage('Cible ajoutée !');
        toast.success('Cible ajoutée à la file d\'attente');
        
        // Rediriger vers les cibles après 1.5s
        setTimeout(() => navigate('/cibles'), 1500);

      } catch (error) {
        console.error('Erreur création cible:', error);
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Erreur lors de l\'ajout');
        setTimeout(() => navigate('/'), 2000);
      }
    };

    createTarget();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <div className="text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-sky-400 mx-auto mb-4" />
            <p className="text-slate-300 font-mono">{message}</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-12 h-12 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-4">
              <Check className="w-6 h-6 text-emerald-400" />
            </div>
            <p className="text-emerald-400 font-mono">{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-6 h-6 text-red-400" />
            </div>
            <p className="text-red-400 font-mono">{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ShareTarget;
